import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle } from '@fortawesome/pro-light-svg-icons'

import { BlankState, Button } from '@domain-group/suit-theme'

import useCampaign from '@hooks/useCampaign'

import type { CampaignModel } from '@models/types'

import BulkSelectImageUrl from '../../assets/select-images.svg'

interface UserGuideBannerProps {
  campaign: CampaignModel,
}

const UserGuideBanner = (props: UserGuideBannerProps) => {
  const { campaign } = props

  const campaignPayload = useCampaign(campaign)
  const {
    callbacks: {
      shareEmailLink,
    },
  } = campaignPayload

  return (
    <BlankState boxProps={{ marginBottom: 'large' }} imageUrl={BulkSelectImageUrl}>
      {/*
       // @ts-expect-error TS2339 */}
      <BlankState.Title>Select Item Media</BlankState.Title>

      {/*
       // @ts-expect-error TS2339 */}
      <BlankState.Paragraph>
        Click on the Select Images links to suggest which images should be used on specific orders and artworks.
        {/*
       // @ts-expect-error TS2339 */}
      </BlankState.Paragraph>

      {/*
       // @ts-expect-error TS2339 */}
      <BlankState.Actions>
        <Button
          buttonStyle="secondaryUtility"
          icon={<FontAwesomeIcon icon={faCheckCircle} />}
          onClick={() => shareEmailLink({
            endPoint: `campaigns/${campaign.id}/users`,
            linkAnchor: 'media-selection',
            preSelectedUsers: [],
          })}
          size="medium"
        >
          Complete Media Selection
        </Button>
        {/*
       // @ts-expect-error TS2339 */}
      </BlankState.Actions>
    </BlankState>
  )
}

export default UserGuideBanner
